var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesertbackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M798 628L543 718C511.833 743.667 449.5 796.9 449.5 804.5C449.5 814 660.5 875.5 678.5 892C692.9 905.2 926.167 976.833 1041 1011L1451.5 1102L1714.5 969.5C1694.33 867 1652.8 661.8 1648 661C1642 660 1175 585 1165.5 585C1157.9 585 917.333 613.667 798 628Z",
    fill: "#FFC349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M625.5 751H409L170.5 776C152 807.333 115 870.7 115 873.5C115 877 255.5 926.5 262.5 929.5C268.1 931.9 512.167 908.5 633.5 896.5L678 820L671.5 767.5L633.5 757.5L625.5 751Z",
    fill: "#9D6528"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 632.5L474.5 438H848L1513 540L1586.5 687L1111 652.5L347.5 714.5L120 632.5Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1404 621C1294.8 656.2 1072.17 617.667 974.5 594L929.5 607.5L865 653.5L944 674.5L1289 730.5H1527L1561.5 563.5C1554.5 568 1513.2 585.8 1404 621Z",
    fill: "#FFD76D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1479 369.5C1385.4 361.9 1171 339.333 1075.5 329L980 358L990 398.5L1089.5 461.5L1408 448.5C1470.67 425.333 1572.6 377.1 1479 369.5Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M722 647C601.2 667 454.167 655.333 403 647L351 746.5L881 695.5C1039.17 722.667 1380.6 782.3 1481 803.5C1581.4 824.7 1572.83 708 1556 647C1520.67 650.167 1408.8 660.5 1244 676.5C1038 696.5 991.5 647 947.5 628C903.5 609 983 599.5 976 593.5C969 587.5 873 622 722 647Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.5 329.5C1059.98 330.285 936 348.833 874 363.5C912.333 398.667 993.3 469.2 1010.5 470C1027.7 470.8 1227.67 495.667 1325.5 508L1470.5 463C1480.33 424.333 1491 350.3 1455 363.5C1410 380 1114.5 399 1092 398C1069.5 397 1075.5 377.5 1069.5 363.5C1063.5 349.5 1041.5 379.151 1016.5 363.651C991.5 348.15 1093 328.5 1074.5 329.5Z",
    fill: "#FEDA84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.062 539.389C314.378 538.886 315.692 538.422 317 538L313.062 539.389C251.987 562.735 184.262 671.186 317 652C486.5 627.5 387 676 393 697C399 718 684.5 695 735.5 695C786.5 695 931.5 692 883 701.5C846.591 708.632 550 790.5 511 800C330.534 843.96 -34.9996 858.5 -94.4996 932C-142.1 990.8 -150 803.167 -148 702L313.062 539.389Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M911 497.5L529 328L-100.5 559L-53 756C47 627.5 381.3 505.9 472.5 489.5C563.7 473.1 800 483.833 911 497.5Z",
    fill: "#DD9F4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M688 273.5C813.833 331.667 1118.7 447 1331.5 443C1535.83 439.159 1593.01 422.718 1597.24 414.038L1597.5 413C1597.5 413.332 1597.42 413.678 1597.24 414.038L1545 623C1416.83 627.833 1122.6 617.3 971 536.5C781.5 435.5 620.988 461.335 572.5 440C522.5 418 522 388.5 544.5 364.5C562.5 345.3 616.167 334.833 645 323L688 299.5V273.5Z",
    fill: "#FEDD8D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M446 309C361.567 355.886 -19.4131 397.273 -88.4995 377.5L-98.5878 593.685L60.5003 545L287.988 459.537C318.535 410.089 530.434 262.114 446 309Z",
    fill: "#FDDE9B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-81.5 914.103C-43.6667 885.27 49.8 827.603 121 827.603C210 827.603 291.5 858.103 443.5 851.103C595.5 844.103 671.5 804.103 669 782.603C667.052 765.847 656.087 762.283 650.437 762.572C650.291 762.583 650.145 762.593 650 762.603C650.142 762.59 650.288 762.58 650.437 762.572C702.147 758.938 816.433 759.289 863.5 789.603C922.5 827.603 1162.5 939.604 1365 906.104C1527 879.304 1589.83 858.27 1601 851.103L1532 1139.6L563.5 1173.6L-142 1159.6L-81.5 914.103Z",
    fill: "url(#paint5_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-21 406C-135 378.8 -112.333 400.833 -137.5 373L-21 583C146.5 533.167 492.9 423 538.5 381C595.5 328.5 704.057 336.842 717.057 309.842C730.057 282.842 686.943 263.658 576 251.5C466.93 239.546 121.5 440 -21 406Z",
    fill: "#EEC068"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1348.5,
    cy: 150.5,
    r: 67.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1348.5,
    cy: 150.5,
    r: 49.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 1231,
    y: 33,
    width: 235,
    height: 235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 1249,
    y: 51,
    width: 199,
    height: 199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 1440,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68A7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 893,
    y1: 670.5,
    x2: 888,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD16B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1040,
    y1: 345.5,
    x2: 1329.5,
    y2: 376.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEB6",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 926,
    y1: 620.5,
    x2: 410.5,
    y2: 666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD56B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 237.5,
    y1: 784,
    x2: 250,
    y2: 573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9F4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 729,
    y1: 975.5,
    x2: 729,
    y2: 767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE843B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AD3D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesertbackground);
export default __webpack_public_path__ + "static/media/desertbackground.4dca7b08a03289bce5e78f5a796686ef.svg";
export { ForwardRef as ReactComponent };